import { render, staticRenderFns } from "./IdeaReels.vue?vue&type=template&id=7265d72b&"
import script from "./IdeaReels.vue?vue&type=script&lang=js&"
export * from "./IdeaReels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports